import { plural } from './streak-reward'

export const LEDGER_TITLES: Readonly<Record<string, string>> = {
  day_reward: 'День орбиты',
  week_reward: 'Неделя орбиты собрана',
  day_repair: 'Закрыт пропущенный день',
  merge_carry: 'Перенос при объединении аккаунтов',
  reading_purchase: 'Разбор у Людмилы',
  reading_refund: 'Возврат за разбор',
  reading_upgrade: 'Доплата за консультацию',
  task_reward: 'Задание выполнено',
  topup: 'Пополнение',
  topup_refund: 'Возврат покупки',
  gift_purchase: 'Подарок: разбор',
  gift_refund: 'Возврат за подарок',
  extra_pick: 'Ещё одна карта дня',
}

export function ledgerTitle(kind: string): string {
  return LEDGER_TITLES[kind] ?? 'Операция'
}

const WEEKDAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'] as const
const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'] as const

function dayKey(d: Date): string {
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
}

export function ledgerWhen(iso: string, now: Date = new Date()): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const time = d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
  if (dayKey(d) === dayKey(now)) return `сегодня, ${time}`
  const yesterday = new Date(now)
  yesterday.setDate(now.getDate() - 1)
  if (dayKey(d) === dayKey(yesterday)) return `вчера, ${time}`
  const year = d.getFullYear() === now.getFullYear() ? '' : ` ${d.getFullYear()}`
  return `${WEEKDAYS[d.getDay()] ?? ''}, ${d.getDate()} ${MONTHS[d.getMonth()] ?? ''}${year}`
}

export function lunarsWord(n: number): string {
  return plural(Math.abs(n), ['лунар', 'лунара', 'лунаров'])
}

export function rub(n: number): string {
  return `${n.toLocaleString('ru-RU')} ₽`
}

export function stars(n: number): string {
  return `${n.toLocaleString('ru-RU')} ⭐`
}

export function signed(n: number): string {
  return `${n > 0 ? '+' : '−'}${Math.abs(n)}`
}
